import { Outlet } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { SectionLayout, SectionSidebar, SectionContent } from "../app-shell/SectionLayout";
import { SettingsCategoryNav } from "./SettingsCategoryNav";

export function SettingsLayout(props: { children?: ReactNode }) {
  return (
    <SectionLayout>
      <SectionSidebar title="Settings">
        <SettingsCategoryNav />
      </SectionSidebar>
      <SectionContent className="p-3 sm:p-4 lg:p-6">{props.children ?? <Outlet />}</SectionContent>
    </SectionLayout>
  );
}
